import { Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UsersPrivilegeService } from './usersPrivilege.service';
import { UsersPrivilegeComponent } from './usersPrivilege.component';
import {UserService } from '../userData/user.service';
import { SharedModule } from '../../shared/shared.module';
import { BlocksModule } from '../../blocks/blocks.module';
import { PriceListService, PriceListServiceService } from '../../pricing/priceListServices/priceListServices.service';
import {  ServiceSettingService } from '../../pricing/services-setting/services-setting.service';
import { ClinicService, ClinicServiceService } from '../../hospitalSetup/clinic-service/clinic-service.service';


@NgModule({
    imports: [SharedModule, CommonModule, BlocksModule],
    declarations: [ UsersPrivilegeComponent],
    providers: [UsersPrivilegeService
        , UserService
        , ServiceSettingService
        , PriceListServiceService
        , ClinicServiceService],
    exports: [UsersPrivilegeComponent]


})
export class UsersPrivilegesComponent { }
